// src/components/Charts/CurrentWeekOrdersChart.js

import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { fetchEventsByCurrentWeek } from '../../app/apiService';  // Adjust the path if necessary
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const eventTypes = ['Install', 'Survey', 'Completed'];

const CurrentWeekOrdersChart = () => {
    const [currentWeekEvents, setCurrentWeekEvents] = useState({
      Install: 0,
      Survey: 0,
      Completed: 0
    });
  
    useEffect(() => {
      // Removed the shadowed 'eventTypes' declaration
      let updatedEvents = {
        Install: 0,
        Survey: 0,
        Completed: 0
      };
    
      eventTypes.forEach((eventType) => {
        fetchEventsByCurrentWeek(eventType)
          .then(events => {
            updatedEvents[eventType] = events.length;  // Update the counts for each event type
            // If this is the last event type, update state
            if (eventType === 'Completed') {
              setCurrentWeekEvents(updatedEvents);
            }
          })
          .catch(error => {
            console.error('Error fetching current week events:', error);
          });
      });
      
    }, []);
  

  const chartData  = {
    labels: eventTypes,
    datasets: [
      {
        label: 'Current Week Order Status',
        data: [currentWeekEvents.Install, currentWeekEvents.Survey, currentWeekEvents.Completed],
        backgroundColor: [
          'rgba(75, 192, 192, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(153, 102, 255, 0.2)'
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(153, 102, 255, 1)'
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    layout: {
        padding: {
          top: 50, // Add this line
        },
      },
    scales: {
      x: {
        type: 'category',
        ticks: {
          font: {
            size: 14, // Example size
            weight: 'bold', // Bolder font
          }
        }
      },
      y: {
        type: 'linear',
        beginAtZero: true,
        ticks: {
          font: {
            size: 14,
            weight: 'bold',
          }
        }
      }
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 14,
            weight: 'bold',
          }
        }
      },
      title: {
        display: false,
        text: 'Order Status by Type',
        font: {
          size: 18,
          weight: 'bold',
        }
      },
      datalabels: {
        color: '#444',
        anchor: 'end',
        align: 'top',
        font: {
            size: 15,
          weight: 'bold',
        },
        formatter: (value, context) => {
          // Only display the label if the value is greater than 0
          return value > 0 ? value : '';
        },
      }
    },
    // ... other options
  };

  return (
    <div style={{ height: '400px' }}>
        <h2 style={{ textAlign: 'center' }}>Order Status by Type</h2> {/* Add this line */}
      <Bar data={chartData} options={options} style={{ height: '300px' }}/>
      
    </div>
  );
};

export default CurrentWeekOrdersChart;
